
export class AcaoReuniao {
    id: number;
    idReuniao: number;
    situacaoTipoAcao: string;
    descricaoAcao: string;
    nomeResponsavel: string;
    dataPrazo: Date;
}
